// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3a6Fp","label":"CategoryService_label__3zsZj","location":"CategoryService_location__3_Ylh"};